import React, { useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AcknowledgementModal = ({
  show,
  onConfirm,
  onCancel,
  requiredWord = 'ENTENDIDO',
  message = 'Para continuar, escribe la palabra requerida.',
}) => {
  const [input, setInput] = React.useState('');

  useEffect(() => {
    if (show) setInput('');
  }, [show]);

  const handleConfirm = () => {
    if (input.trim().toLowerCase() === requiredWord.toLowerCase()) {
      onConfirm();
    }
  };

  return (
    <Modal show={show} onHide={onCancel} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmación requerida</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
        <p className="user-select-none" style={{ userSelect: 'none' }}>
          Escribe manualmente la palabra: <strong>{requiredWord}</strong>
        </p>
        <Form.Control
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={`Escribe "${requiredWord}"`}
          autoFocus
          onCopy={(e) => e.preventDefault()}
          onPaste={(e) => e.preventDefault()}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={input.trim().toLowerCase() !== requiredWord.toLowerCase()}
        >
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AcknowledgementModal;
